import React, { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

export default function AdminFixProgress() {
  const { user } = useAuth();
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const fixProgress = async () => {
    if (!user) {
      setResult('Error: Not authenticated');
      return;
    }

    setLoading(true);
    try {
      // Update communication-systems to completed
      const { data, error } = await supabase
        .from('user_progress_detailed')
        .update({
          status: 'completed',
          progress_percentage: 100,
          updated_at: new Date().toISOString()
        })
        .eq('user_id', user.id)
        .eq('content_id', 'communication-systems')
        .eq('content_type', 'micro')
        .select();

      if (error) throw error;

      setResult(`✅ Success! Fixed Communication Systems progress.\n\nUpdated: ${JSON.stringify(data, null, 2)}\n\nRefresh the dashboard to see changes.`);
    } catch (err: any) {
      setResult(`❌ Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-2xl font-bold mb-4">Admin: Fix Progress for Communication Systems</h1>
      <p className="mb-4 text-slate-600">
        This will mark "Communication Systems" (communication-systems) as completed with 100% progress.
      </p>
      <p className="mb-6 text-sm text-slate-500">
        User: {user?.email || 'Not logged in'}
      </p>

      <Button onClick={fixProgress} disabled={loading || !user}>
        {loading ? 'Fixing...' : 'Fix Communication Systems Progress'}
      </Button>

      {result && (
        <pre className="mt-4 p-4 bg-slate-100 rounded text-sm whitespace-pre-wrap">
          {result}
        </pre>
      )}
    </div>
  );
}
